import { useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { downloadPostcardPng } from "@/lib/attachments";

export const PngDownloadLink = ({ asset, className = "", label = "Download as PNG (for print shops)" }) => {
  const [busy, setBusy] = useState(false);
  if (!asset.postcard) return null;
  const go = async () => {
    setBusy(true);
    try { await downloadPostcardPng(asset.id); }
    catch { toast.error("Couldn't create the PNG. Please try again."); }
    finally { setBusy(false); }
  };
  return (
    <button type="button" onClick={go} disabled={busy} className={`inline-flex items-center justify-center gap-1 text-xs text-muted-foreground hover:text-foreground underline-offset-2 hover:underline disabled:opacity-60 ${className}`} data-testid={`marketing-asset-png-${asset.id}`}>
      {busy && <Loader2 className="w-3 h-3 animate-spin" />}{label}
    </button>
  );
};
